import React from 'react'

import {
  FixedAction,
  Button,
} from '../styles'

const OverAction = ({history}) => {
  return <FixedAction>
      <Button onClick={() => history.push('/')}>Back home</Button>
    </FixedAction>
}

export default OverAction



// WEBPACK FOOTER //
// ./src/views/game/3_OverAction.jsx